import { Stack } from '@mui/joy';
import { upperFirst } from 'lodash';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { ColoredChip, Loader } from 'core/elements';
import { UpsertPartBom } from 'partBoms/components';
import { IPartBomDetails } from 'partBoms/types';
import { TaxonomyHelper } from 'taxonomy/helpers';

interface IProps {
  partBom: IPartBomDetails;
  onSubmitSuccess?: (partBom: IPartBomDetails) => void;
  isLoading?: boolean;
  isEditable?: boolean;
}

export const Details = ({ partBom, onSubmitSuccess, isLoading, isEditable = true }: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const { t } = useTranslation();

  const items = useMemo(() => {
    if (!partBom?.id) {
      return [];
    }

    return [
      {
        label: t('labelPartBomType'),
        value: <ColoredChip value={upperFirst(partBom.bomType)} />,
      },
      {
        label: t('labelPartBomUom'),
        value: partBom.uom,
      },
      {
        label: t('labelTaxonomy'),
        value: TaxonomyHelper.getLastLevelTaxonomy(partBom.taxonomyPath)?.name,
      },
    ];
  }, [t, partBom?.id, partBom?.bomType, partBom?.uom, partBom?.taxonomyPath]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Stack>
      <InfoCard
        title={t('titleMainInfo')}
        items={items}
        onEdit={() => setIsEditOpen(true)}
        isEditable={isEditable}
      />

      {isEditable && (
        <UpsertPartBom
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          partBom={partBom}
          onSubmitSuccess={onSubmitSuccess}
          level={1}
        />
      )}
    </Stack>
  );
};
